





































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { AuthModule } from "@/store/auth.module";
import { AppealsModule } from "@/store/appeals.module";
import DatePicker from "@/components/ui/DatePicker.vue";
import moment from "moment";
import { translate } from "@/utils";
import { Appeal, AppealDTO, AppealStatus } from "../../../../lib/appeal.type";
import TableCellTooltip from "@/components/ui/TableCellTooltip.vue";

@Component({ components: { DatePicker, TableCellTooltip } })
export default class AppealsOut extends Vue {
  newAppeal() {
    AppealsModule.newAppeal();
  }

  openAppeal(item: Appeal) {
    AppealsModule.openAppeal(item.request_rid);
  }

  get appealListLength() {
    return AppealsModule.appealListLength;
  }

  get appealListPagination() {
    return AppealsModule.appealListPagination;
  }
  set appealListPagination(val) {
    AppealsModule.setAppealListPagination(val);
    this.loadTableAppeal();
  }
  get getAppealList(): Appeal[] {
    return translate(AppealsModule.appealList);
  }
  get appealHeaders() {
    return [
      {
        text: this.$t("appeals.number"),
        value: "request_number",
        sortable: false,
      },
      {
        text: this.$t("appeals.date_create"),
        value: "request_date",
        sortable: false,
      },
      {
        text: this.$t("appeals.theme"),
        value: "request_type_name",
        sortable: false,
      },
      {
        text: this.$t("appeals.contract"),
        value: "contract_number",
        sortable: false,
      },
      {
        text: this.$t("appeals.status"),
        value: "request_state_name",
        sortable: false,
      },
      {
        text: "",
        value: "",
        sortable: false,
      },
    ];
  }

  get appealLoading() {
    return AppealsModule.appealLoading;
  }

  get statusList() {
    return translate(AppealsModule.appealStatusList);
  }

  get typeList() {
    return translate(AppealsModule.appealTypeList);
  }

  get user() {
    return AuthModule.user as IUser;
  }

  from = "";
  to = "";
  current = "";
  statusRid: number = null as any;
  canReq: boolean = false;

  @Watch("from") updateFrom() {
    this.appealListPagination.page = 1;
    this.loadTableAppeal();
  }

  @Watch("to") updateTo() {
    this.appealListPagination.page = 1;
    this.loadTableAppeal();
  }

  @Watch("statusRid") updatestatusRid() {
    this.appealListPagination.page = 1;
    this.loadTableAppeal();
  }

  async loadTableAppeal() {
    if (!this.canReq) return;
    AppealsModule.setAppealsLoadig();
    const req: AppealDTO = new AppealDTO();
    req.BIN = this.user.bin;
    req.DateBegin = moment(String(this.from)).format("YYYY-MM-DD");
    req.DateEnd = moment(String(this.to)).format("YYYY-MM-DD");

    req.Status = this.statusRid;
    req.TypeRid = 1;
    (req.iLimit = this.appealListPagination.itemsPerPage),
      (req.iOffset =
        this.appealListPagination.itemsPerPage *
        (this.appealListPagination.page - 1));
    await AppealsModule.loadAppealList(req);
  }

  async mounted() {
    this.current = moment().format("YYYY-MM-DD");
    this.from = moment()
      .add(-6, "month")
      .format("YYYY-MM-DD");
    this.to = this.current;
    await AppealsModule.loadSatatuses(1);
    await AppealsModule.loadTypes();
    this.canReq = true;
    await this.loadTableAppeal();
  }
}
